/*
 * PYG ambient video controller.
 * - Videos autoplay muted only while on screen (battery + bandwidth).
 * - Offscreen videos pause; nothing downloads until near the viewport.
 * - Each video gets an accessible pause/play toggle the user controls;
 *   a user pause wins over the observer.
 * - Respects prefers-reduced-motion: videos stay paused on poster frame.
 */
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var sections = document.querySelectorAll('[data-pyg-ambient]');
  if (!sections.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var section = entry.target;
        var video = section.querySelector('video');
        if (!video) return;
        var userPaused = section.classList.contains('pyg-feature--paused');
        if (entry.isIntersecting && !userPaused && !reducedMotion) {
          if (video.preload === 'none') video.preload = 'metadata';
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
        }
      });
    },
    { rootMargin: '100px 0px' }
  );

  sections.forEach(function (section) {
    var video = section.querySelector('video');
    var toggle = section.querySelector('.pyg-feature__pause');
    if (!video) {
      if (toggle) toggle.hidden = true;
      return;
    }
    if (reducedMotion) section.classList.add('pyg-feature--paused');
    observer.observe(section);

    if (toggle) {
      toggle.addEventListener('click', function () {
        var paused = section.classList.toggle('pyg-feature--paused');
        toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
        if (paused) {
          video.pause();
        } else {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
      });
    }
  });
})();
